// extracted by mini-css-extract-plugin
export default {"tabs":"BottomTabs_tabs__6WHo5","indicator":"BottomTabs_indicator__BN1oc"};